module.exports = __webpack_public_path__ + "img/vi.0cdff09.svg";